import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render - price list subscriptions
const PriceListInquiry = Loadable(lazy(() => import('pages/subscriptions/pricelist/pricelist-inquiry')));
const NewDealerInquiry = Loadable(lazy(() => import('pages/newdealer/newdealer-inquiry')));

// pages routing
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'subscriptions',
          children: [
            {
              path: 'pricelist',
              children: [
                {
                  path: 'list',
                  element: <PriceListInquiry />
                }
              ]
            }
          ]
        },
        {
          path: 'newdealer',
          children: [
            {
              path: 'pricelist',
              children: [
                {
                  path: 'list',
                  element: <NewDealerInquiry />
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        }
      ]
    }
  ]
};

export default MainRoutes;
